import getComponentClasses from '@99designs/frontend-components/utils/app/getComponentClasses';
import * as React from 'react';
import { AvatarSize } from './Avatar';

export function AvatarSkeleton({ size = 'medium' }: { size?: AvatarSize }) {
    return (
        <span className={getComponentClasses('avatar', [size, 'square', 'skeleton'])}>
            <div className="avatar__image" />
        </span>
    );
}
